/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';
import type { GetMeResp } from './GetMeResp';
import {
    GetMeRespFromJSON,
    GetMeRespFromJSONTyped,
    GetMeRespToJSON,
} from './GetMeResp';

/**
 * 
 * @export
 * @interface GetMe200Response
 */
export interface GetMe200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetMe200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetMe200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {GetMeResp}
     * @memberof GetMe200Response
     */
    result: GetMeResp;
}

/**
 * Check if a given object implements the GetMe200Response interface.
 */
export function instanceOfGetMe200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetMe200ResponseFromJSON(json: any): GetMe200Response {
    return GetMe200ResponseFromJSONTyped(json, false);
}

export function GetMe200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMe200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': GetMeRespFromJSON(json['result']),
    };
}

export function GetMe200ResponseToJSON(value?: GetMe200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': GetMeRespToJSON(value.result),
    };
}

